<template>
  <video :src="videoParam.filePath" controls autoplay muted style="width: 100%; height: 100%"
         @ended="playNext()">
    您的浏览器不支持视频播放
  </video>
</template>

<script>
  let list = []
  export default {
    name: "eleVideos",
    props: {
      componentData: {
        type: String
      },
      showFlag: {
        type: Array
      }
    },
    created() {
      if (this.componentData) {
        this.videoData = JSON.parse(this.componentData);
        list = JSON.parse(this.videoData.param);
        this.videoParam = list.filter(x => x.flag == this.videoData.defaultFlag)[0];
      }
    },
    data() {
      return {
        videoData: {},
        videoParam: {},
      }
    },
    methods: {
      playNext() {
        if (this.videoData.repeatFlag == 1) {
          list.filter(x => this.videoParam.flag != x.flag).forEach(x => this.videoParam = x)
        }
      }
    },
    watch: {
      showFlag: {
        handler(val) {
          this.videoParam = list.filter(x => x.flag.indexOf(val) != -1)[0];
        }
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/lib/showMoudle/eleVideos.vue